import { calculateCoordFromPointWithDistance } from "@nova/calculate-geospatial"
import { TrackedAircraft } from "@nova/constants"

const KNOTS_TO_METERS_PER_SECOND = 0.514444
const FEET_PER_MINUTE_TO_FEET_PER_SECOND = 1 / 60

export const projectAircraftPosition = (
    aircraft: TrackedAircraft,
    now: number
): TrackedAircraft => {
    const elapsedSeconds = (now - aircraft.timestamp) / 1000
    const altitude = Math.round(
        aircraft.altitude +
            aircraft.verticalRate * FEET_PER_MINUTE_TO_FEET_PER_SECOND * elapsedSeconds
    )

    if (aircraft.speed <= 0) return { ...aircraft, altitude }

    const distanceMeters = aircraft.speed * KNOTS_TO_METERS_PER_SECOND * elapsedSeconds
    const [lng, lat] = calculateCoordFromPointWithDistance(
        [aircraft.lng, aircraft.lat],
        aircraft.heading,
        distanceMeters
    )

    return { ...aircraft, lat, lng, altitude }
}
